// extracted by mini-css-extract-plugin
export default {"subheaderToolbarDivider":"styles_subheader-toolbar-divider__4pD3-"};